export enum VendorsTableColumnId {
  Vendor = 'name',
  TotalAccounts = 'totalAccounts',
  AccountType = 'accountType',
  Actions = 'actions',
}
